import * as React from "react";

function ReturnIcon({ width = "100%", className, style, fill = "none" } = {}) {
    return (
        <svg className={className} width={width} style={style} viewBox="0 0 123 123" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_441:296)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.45027 80.7785V61.7543C6.45027 59.5087 9.29052 56.6685 11.5352 56.6685H39.1725C41.1638 56.6685 41.7779 56.0544 41.7779 54.064V31.4345H105.541V37.7596H97.9126C93.1671 37.7596 93.1671 43.9695 97.9126 43.9695H105.541V51.9391H87.2372C82.4907 51.9391 82.4907 58.1489 87.2372 58.1489H105.541V80.7775H97V86.9874H108.145C110.136 86.9874 111.751 85.3733 111.751 83.3829V72.5677H119.681C124.427 72.5677 124.427 66.3588 119.681 66.3588H111.751V58.1489H119.681C124.427 58.1489 124.427 51.9391 119.681 51.9391H111.751V43.9695H116.076C120.822 43.9695 120.822 37.7596 116.076 37.7596H111.751V28.8291C111.751 26.8387 110.136 25.2246 108.145 25.2246C102.628 25.2246 41.9962 25.2481 41.9962 25.2246C32.1278 25.2246 23.5319 30.11 18.4738 38.598L11.4057 50.4596C5.23749 50.529 0.240425 55.5749 0.240425 61.7534V83.3829C0.240425 85.3733 1.85451 86.9874 3.84489 86.9874H14V80.7785H6.45027ZM35.568 50.4586H18.7726L23.6421 41.2869C26.2077 36.9805 30.9689 33.8856 35.568 32.4114V50.4586Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 97C31.1797 97 37 91.1797 37 84C37 76.8203 31.1797 71 24 71C16.8203 71 11 76.8203 11 84C11 91.1797 16.8203 97 24 97ZM24 91C27.866 91 31 87.866 31 84C31 80.134 27.866 77 24 77C20.134 77 17 80.134 17 84C17 87.866 20.134 91 24 91Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M87 97C94.1797 97 100 91.1797 100 84C100 76.8203 94.1797 71 87 71C79.8203 71 74 76.8203 74 84C74 91.1797 79.8203 97 87 97ZM87 91C90.866 91 94 87.866 94 84C94 80.134 90.866 77 87 77C83.134 77 80 80.134 80 84C80 87.866 83.134 91 87 91Z"
                />
                <path d="M34 80.7793H77V86.99H34V80.7793Z" />
            </g>
        </svg>
    );
}

export default ReturnIcon;
